'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexPropTypes = exports.flexDefaultProps = exports.isValidFlexWrap = exports.isValidJustifyContent = exports.isValidAlignItems = exports.isValidAlignContent = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isValidAlignContent = exports.isValidAlignContent = _propTypes2.default.oneOf(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'stretch']);

var isValidAlignItems = exports.isValidAlignItems = _propTypes2.default.oneOf(['baseline', 'center', 'flex-end', 'flex-start', 'stretch']);

var isValidJustifyContent = exports.isValidJustifyContent = _propTypes2.default.oneOf(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly']);

var isValidFlexWrap = exports.isValidFlexWrap = _propTypes2.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']);

var flexDefaultProps = exports.flexDefaultProps = {
  alignContent: 'flex-end',
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start'
};
var flexPropTypes = exports.flexPropTypes = {
  alignContent: isValidAlignContent,
  alignItems: isValidAlignItems,
  display: _propTypes2.default.string,
  flexWrap: isValidFlexWrap,
  justifyContent: isValidJustifyContent
};